/** Defines basic information about a machine cabin. */
export interface CabinInfo {
  layout: string;
  size: string;
}
